import type { NotificationProvider } from "@refinedev/core";
import { notification } from "antd";
import type { MessageInstance } from "antd/es/message/interface";

export const notificationProvider: (
  message: MessageInstance
) => NotificationProvider = (messageInstance) => ({
  open: ({ message, key, type, description }) => {
    if (type === "progress") {
      messageInstance.loading({ content: message, key });
    } else if (type === "success") {
      let realKey = "";
      if (key?.startsWith("notification")) {
        realKey = key;
        messageInstance.success({
          content: message || "操作に成功しました。",
          key: realKey,
          className: "whitespace-break-spaces",
        });
      }
    } else if (type === "error") {
      if (key === "login-error") {
        notification.error({ message: description, key });
      } else if (key?.startsWith("notification")) {
        messageInstance.error({
          content: message || "操作に失敗しました。",
          key,
          className: "whitespace-break-spaces",
        });
      } else {
        if (key === "timeout") {
          messageInstance.error({
            content: "ネットワークがタイムアウトしました。",
            key,
          });
        }
      }
    }
  },
  close(key) {
    messageInstance.destroy(key);
  },
});
